import { FC } from 'react';
import { useSelector } from 'react-redux';

import type { PsychicComponentInterface } from 'types/componentTypes';
import { useProfileLink } from 'src/shared/lib/psychics/hooks';
import { Text } from 'src/__generated__/graphqlTypes';
import { getPsychicCtaButtons, getStatus } from 'lib/psychic.service';
import { Store } from 'app-redux/types/storeTypes';
import variables from 'src/styles/_commonVariables.module.scss';

import SmallCard from './SmallCard';
import MediumCard from './MediumCard';

import { useTextLengthLimit } from '../lib/hooks';

const Card: FC<PsychicComponentInterface> = ({
  psychicSkeleton: psychicFrame,
  positionInArray,
  bootStatus,
  psychic,
  user,
}) => {
  const clientWidth = useSelector((store: Store) => store.client.app.clientWidth);
  const textLengthLimit = useTextLengthLimit(clientWidth);
  const cta = getPsychicCtaButtons(psychic, psychicFrame, { hashedId: user?.hashedId });
  const linkProps = useProfileLink(psychicFrame, psychic, positionInArray);
  const moreText = (psychicFrame.extraTextsCollection?.items?.find((item) => item?.slug === 'more') || {}) as Text;
  const status = getStatus({
    chatStatus: psychic.chatStatus,
    phoneStatus: psychic.phoneStatus,
  });

  const isSmallView = clientWidth <= Number(variables.commonTabletMaxWidth);

  if (isSmallView) {
    return (
      <SmallCard
        psychic={psychic}
        psychicFrame={psychicFrame}
        positionInArray={positionInArray}
        linkProps={linkProps}
        status={status}
        cta={cta}
        bootStatus={bootStatus}
      />
    );
  }

  return (
    <MediumCard
      psychicFrame={psychicFrame}
      positionInArray={positionInArray}
      bootStatus={bootStatus}
      psychic={psychic}
      status={status}
      cta={cta}
      linkProps={linkProps}
      moreText={moreText?.text as string}
      textLengthLimit={textLengthLimit}
    />
  );
};

export default Card;
